import { defineStore } from 'pinia'
import { supabase } from '@/main.js'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    error: null,
  }),
  actions: {
    async signUp(email, password) {
      try {
        const { data, error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
        this.user = data.user;
        this.error = null;
      } catch (err) {
        this.user = null;
        this.error = err.message;
      }
    },

    async signIn(email, password) {
      console.log("Signing in with email:", email);
      console.log("Signing in with password:", password);
      try {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
        this.user = data.user;
        this.error = null;
        return data.user;
      } catch (err) {
        this.user = null;
        this.error = err.message;
        return null;
      }
    },

    async signOut() {
      try {
        const { error } = await supabase.auth.signOut();
        if (error) throw error;
        this.user = null;
        this.error = null;
      } catch (err) {
        this.error = err.message;
      }
    },

    async fetchUser() {
      try {
        const { data, error } = await supabase.auth.getUser();
        if (error) throw error;
        this.user = data.user;
        return data.user;
      } catch (err) {
        this.user = null;
        this.error = err.message;
        return null;
      }
    },
  },
})
